<template>
  <div class="notebox" :class="{ show: show }" key="iframe1">
    <div class="chatbox-session">
      <div class="canvas">
        <div class="headerbox">
          <strong class="flex align-items-center">
            <span v-if="view == 'note'">
              Note
              <template v-if="env === 'prod'">
                <a href="https://app.fexspace.com/notes">All Notes</a>
              </template>
              <template v-if="env === 'local'">
                <a href="https://192.168.1.2:9009/notes">All Notes</a>
              </template>
            </span>
            <span v-if="view == 'chat'">Messenger</span>
            <span v-if="view == 'notification'">Notifications</span>
          </strong>

          <span class="close" @click="closebox">
            <svg style="width: 20px; height: 20px" viewBox="0 0 24 24">
              <path
                fill="currentColor"
                d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
              />
            </svg>
          </span>
        </div>
        <div class="w-full" style="height: calc(100% - 4.5rem)">
          <iframe
            ref="iframe_note"
            @load="load"
            class="w-full h-full"
            :src="src"
            frameborder="0"
          ></iframe>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.show {
  transform: translateX(0%);
}
.headerbox {
  background: #fff;
  font-weight: normal;
  padding: 1.5rem 1rem;
  font-family: arial;
  display: flex !important;
  justify-content: flex-start;
  align-items: center;
  text-align: left;
}

.close {
  cursor: pointer;
  width: 2rem;
  height: 2rem;
  background-color: #f2f7fc;
  color: #677888;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}
strong {
  color: #111;
  text-transform: capitalize;
  font-weight: 600;

  font-size: 1.125rem;

  flex-grow: 1;
}
strong > span {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
strong > span a {
  color: #2a7bb1;
  font-size: 0.875rem;
  margin-right: 1rem;
}
strong > span a:hover {
  text-decoration: none;
}
.canvas {
  width: 24.4375rem;
  height: 100%;
  right: 0;
  position: fixed;
  -webkit-box-shadow: -10px 4px 61px 0px #757f8838;
  box-shadow: -10px 4px 61px 0px #757f8838;
}
</style>
<script>
import { mapMutations } from "vuex";
export default {
  data() {
    return {
      env: process.env.NODE_ENV === "development" ? "local" : "prod",
    };
  },
  methods: {
    ...mapMutations([
      "TOGGLE_EMBED",
      "SET_TOTAL_NOTIFICATION",
      "SET_TOTAL_CHAT",
    ]),
    load() {
      this.iframe.postMessage({ view: this.view }, "*");
    },
    closebox() {
      this.TOGGLE_EMBED(this.view);
    },
  },
  computed: {
    view() {
      return this.$store.getters.EMBED_TYPE;
    },
    show() {
      return this.$store.getters.SHOW_EMBED;
    },
    src() {
      return process.env.VUE_APP_EMBED;
    },
    iframe() {
      /** @type {HTMLIFrameElement} */
      const iframe = this.$refs.iframe_note;
      return iframe.contentWindow;
    },
  },
  watch: {
    view(curState, prevState) {
      this.iframe.postMessage(
        {
          type: "ready",
          view: curState,
          data: { serverOrigin: process.env.VUE_APP_DASHBOARD },
        },
        "*"
      );
    },
  },
  mounted() {
    const ths = this;
    window.addEventListener(
      "message",
      function (ev) {
        if (ev.data) {
          if (ev.data.kind === "LINK") {
            location.href = ev.data.data;
          } else if (ev.data.isReady) {
            ths.load();
          } else if (ev.data.kind === "CHAT") {
            console.log(ev.data.data);
            ths.SET_TOTAL_CHAT(ev.data.data);
          } else if (ev.data.kind === "NOTIFICATION") {
            console.log(ev.data.data);
            ths.SET_TOTAL_NOTIFICATION(ev.data.data);
          }
        }
      },
      false
    );
  },
};
</script>
